module.exports = __webpack_public_path__ + "assets/img/smartTV-module3-1.b413cb2a.jpg";